import React from 'react';
import PropTypes from 'prop-types';
import { Editor } from '../../editor-ui';

export default function FieldEditor({
  storyId,
  format,
  fieldTemplateId,
  onDispatchTransaction,
  consumerApi,
  characterLimit,
  contentType,
  defaultContent,
}) {
  const fieldFormat = `${storyId}-${format === 'standard' ? 'mini' : 'rich'}-${fieldTemplateId}`;

  return <Editor
          roomName={fieldFormat}
          onDispatchTransaction={onDispatchTransaction}
          consumerApi={consumerApi}
          plugins={[]}
          minHeight={'unset'}
          characterLimit={characterLimit}
          contentType={contentType}
          defaultContent={defaultContent}
          />;
}

FieldEditor.defaultProps = {
  contentType: 'text',
  characterLimit: undefined,
  defaultContent: '',
};

FieldEditor.propTypes = {
  storyId: PropTypes.number.isRequired,
  format: PropTypes.string.isRequired,
  fieldTemplateId: PropTypes.number.isRequired,
  onDispatchTransaction: PropTypes.func.isRequired,
  consumerApi: PropTypes.object.isRequired,
  characterLimit: PropTypes.number,
  contentType: PropTypes.string,
  defaultContent: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/FieldEditor.jsx